<template>
	<el-drawer size="800px" title="高级设置" :visible.sync="show" :modal-append-to-body="false" :wrapperClosable="false" :before-close="closeBox" :destroy-on-close="true">
		<el-container class="weibo-advanced">
			<el-header>
				<el-tabs type="card" v-model="active">
					<el-tab-pane v-for="(item,index) in tabs" :label="item" :name="item" :key="index"></el-tab-pane>
				</el-tabs>
			</el-header>
			<el-main>
				<KeywordView v-if="active == '关键词回复'" v-bind="$attrs" />
				<MessageView v-else v-bind="$attrs" />
			</el-main>
		</el-container>
	</el-drawer>
</template>

<script>
	import KeywordView from './keyword';
	import MessageView from './message';
	export default {
		components:{
			KeywordView,
			MessageView
		},
		model:{
			prop:'show',
			event:'close'
		},
		props:{
			show:{
				default:false,
				type:Boolean
			},
			// source:{
			// 	default:''
			// }
		},
		data(){
			return {
				tabs:['关键词回复','收到消息回复'],
				active:'关键词回复'
			}
		},
		methods:{
			closeBox(){
				this.$emit('close',false)
			},
		}
	}
</script>

<style>
</style>